<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('ffc-banner')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New FCC Banner</h2>
    </div>

    <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator"> -->
    <!-- <b-form role="form"> -->
    <base-input
      alternative
      class="mb-3"
      name="Sub Heading"
      placeholder="Sub Heading"
      v-model="subHeading"
    >
    </base-input>
    <base-input
      alternative
      class="mb-3"
      name="Heading"
      placeholder="Heading"
      v-model="title"
    >
    </base-input>
    <base-input
      alternative
      class="mb-3"
      name="Description"
      placeholder="Description"
      v-model="body"
    >
    </base-input>
    <base-input
      alternative
      class="mb-3"
      name="CTA"
      placeholder="CTA"
      v-model="ctaBody"
    >
    </base-input>
    <base-input
      alternative
      class="mb-3"
      name="CTA Route"
      placeholder="CTA Route"
      v-model="ctaRoute"
    >
    </base-input>
    <!-- <el-select
          class="w-full rounded-lg mb-3"
          v-model="type"
          placeholder="Select type as a main banner or other small banners"
        >
          <el-option
            v-for="item in typeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
    <div
      class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
    >
      Recommended Size: 800 × 500px
    </div>
    <FileUploader v-show="!image" :image="image" :onSuccess="handleSuccess" />

    <div class="flex cursor-pointer items-center my-2" v-if="image">
      <base-button type="danger" class="px-8" @click="handleRemove">
        Remove image
      </base-button>
    </div>
    <!-- <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span> -->
    <img v-if="image" :src="image" ref="cover" />

    <base-button
      type="primary"
      outline
      class="w-full my-2"
      native-type="submit"
      @click="onSubmit()"
      >Create</base-button
    >
    <!-- </b-form> -->
    <!-- </validation-observer> -->
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      subHeading: "",
      title: "",
      image: null,
      coverImage: null,
      body: "",
      ctaBody: "",
      ctaRoute: "",
      // type: "",
      buttonName: "",
      redirectTo: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      typeOption: [
        {
          value: "main",
          label: "Main",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      msg: {},
    };
  },

  methods: {
    handleSuccess(image) {
      console.log(image, "IMGEE");
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("heading", this.title);
      data.append("description", this.body);
      data.append("cta", this.ctaBody);
      data.append("ctaRoute", this.ctaRoute);
      data.append("subHeading", this.subHeading);
      if (this.coverImage == "") {
        this.$swal.fire({
          text: "Please Select Image or Upload SVG Image only",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } else {
        data.append("image", this.coverImage);
      }

      // data.append("type", this.type);
      //   data.append("redirectTo", this.redirectTo);
      //   data.append("buttonName", this.buttonName);
      // let loader = this.$loading();

      // try {
      const blogdata = await this.$store.dispatch("ffc/add_banner", data);
      if (blogdata.code == 200) {
        console.log(blogdata.data, "BLOGDATA");
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your banner has been successfully added to the website",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        await this.$router.push({ name: "ffc-banner" });
      }
      // this.$swal.fire({
      //   title: "Congratulations!",
      //   text: "Your banner has been successfully added to the website",
      //   icon: "success",
      //   confirmButtonText: "Okay",
      //   confirmButtonColor: "#830c81",
      //   showCancelButton: false,
      // });
      // this.$router.push({ name: "ffc-banner" });
      // }
      // loader.close();
      // } catch (error) {
      //   if (error) {
      //     loader.close();
      //   }
      // }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
